import * as React from 'react';
import { Properties, RedirectCandidateSearch } from '../';
import { IRedirect, DOMHelper, IRedirectCandidate, IOutputValue, IOption } from '../../helpers';
import {
	DialogFooter,
	Button, ButtonType, Pivot, PivotItem, PivotLinkSize, IDropdownOption
} from 'office-ui-fabric-react';
import { QueryStringBuilder } from './query-string-builder';
import { RedirectCandidateConfig } from './redirect-candidate-config';
import { QUERY_STRING_PROPERTY_NAME } from '../../constants';
import store from '../../store/store';

interface IProps {
	redirect: IRedirect;
	queryString: string;
	onQueryStringChange: (queryString: string) => void;
	closeDialog: (save?: boolean) => void;
	updateProperty: (key: string, value: any) => void;
	componentId: string;
	selectedCandidate: IRedirectCandidate;
	onSearchResultClicked: (candidate: IRedirectCandidate) => void;
	updateSearchResults: (searchTerm: string) => void;
	onSearchBlur: () => void;
	redirectCandidateResults: IRedirectCandidate[];
	term: string;
	awaitingResults: boolean;
	outputOptions: IDropdownOption[];
	candidateTypeOptions: IOption[];
	onCandidateTypeChanged: (option: IDropdownOption, index?: number) => void;
	onCandidatePropertyChanged: (name: string, value: string, componentId: string) => void;
}

export class 
RedirectConfig extends React.Component<IProps, any> {

	constructor(props: any) {
		super(props);
	}

	private saveBlur = () => {
		if (DOMHelper) {
			DOMHelper.focusOnFirstModalTabbableControl();
		}
	}

	close(bool: boolean) {
		let { closeDialog,
		} = this.props;

		closeDialog(bool);
		if (store.getState().modalState.modal.errorMessages.length === 0)
			store.getState().modalState.redirectConfig.componentId = '';
	}

	public render() {

		let { redirect, closeDialog, updateProperty, queryString, onQueryStringChange,
			componentId, onSearchBlur, onSearchResultClicked, updateSearchResults,
			selectedCandidate, term, redirectCandidateResults, awaitingResults, candidateTypeOptions,
			outputOptions, onCandidatePropertyChanged, onCandidateTypeChanged
		} = this.props;

		return (<div>
			<Pivot linkSize={PivotLinkSize.large}>
				<PivotItem linkText={"Properties"}>
					<div>
						<div className="ms-TextField">
							<RedirectCandidateSearch componentId={componentId}
								onSearchBlur={onSearchBlur}
								onSearchResultClicked={onSearchResultClicked}
								updateSearchResults={updateSearchResults}
								selectedCandidate={selectedCandidate}
								term={term}
								redirectCandidateResults={redirectCandidateResults}
								awaitingResults={awaitingResults}
							/>
						</div>

						<RedirectCandidateConfig selectedCandidate={selectedCandidate}
							candidateTypeOptions={candidateTypeOptions}
							componentId={componentId}
							outputOptions={outputOptions}
							onCandidatePropertyChanged={onCandidatePropertyChanged}
							onCandidateTypeChanged={onCandidateTypeChanged}
						/>

						<Properties primaryOnly={false}
							change={updateProperty}
							componentId={redirect.ComponentId}
							properties={redirect.Properties.filter(p => p.Name != QUERY_STRING_PROPERTY_NAME)}
							outputOptions={outputOptions}
						/>
					</div>
				</PivotItem>
				<PivotItem linkText={"Parameters"}>
					<QueryStringBuilder queryString={queryString} onChange={onQueryStringChange} outputOptions={outputOptions} />
				</PivotItem>
			</Pivot>
			<DialogFooter>
				<Button tabIndex={1001} buttonType={ButtonType.normal} onClick={() => this.close(false)}>Cancel</Button>
				<Button tabIndex={1002} onBlur={this.saveBlur}
					buttonType={ButtonType.primary} onClick={() => this.close(true)}>Save</Button>
			</DialogFooter>
		</div>);
	}

}


// WEBPACK FOOTER //
// ./source/ts/components/redirect/redirect-config.tsx